import { getImpersonationToken } from '@sonnen/web-utils';
import ReactDOM from 'react-dom/client';
import { initSentry } from './tools/sentry/sentry';

initSentry();

const isReloadableChunkError = (error: unknown): error is Error => {
  return (
    error instanceof Error &&
    (error.message.includes('Failed to fetch dynamically imported module') ||
      error.message.includes('Importing a module script failed') ||
      error.message === 'Load failed' ||
      error.name === 'ChunkLoadError')
  );
};

const registerChunkReloadHandler = () => {
  window.addEventListener('unhandledrejection', (event) => {
    if (!isReloadableChunkError(event.reason)) return;

    const reloadKey = 'chunk_reload_attempted';
    if (sessionStorage.getItem(reloadKey)) return;

    sessionStorage.setItem(reloadKey, '1');
    window.location.reload();
  });
};

registerChunkReloadHandler();

if (getImpersonationToken()) {
  localStorage.removeItem('web-utils:user');
}

const element = document.getElementById('root');
const root = ReactDOM.createRoot(element!);

const mountApp = async () => {
  const { default: AppRoot } = await import('./AppRoot');
  root.render(<AppRoot />);
};

void mountApp();
